import { Component, OnInit } from "@angular/core";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { SessionKey } from "@shared/clickar-constants";
import { StorageManagerService } from "@shared/services/storage/storage-manager.service";
import { WcmService } from "@shared/services/wcm/wcm.service";

@Component({
	selector: "app-private-privacy",
	templateUrl: "./private-privacy.component.html",
	styleUrl: "./private-privacy.component.scss",
	standalone: false
})
export class PrivatePrivacyComponent implements OnInit {
	privacy: any;
	localizedCountry: any;

	constructor(
		public wcmService: WcmService,
		public translate: TranslateService,
		private storageService: StorageManagerService
	) { }

	ngOnInit() {
		this.localizedCountry = this.storageService.getSessionItem(
			SessionKey.GEOLOCATION_MARKET,
			this.translate.getCurrentLang().slice(3)
		);

		this.translate.onLangChange.subscribe(
			(event: LangChangeEvent) => {
				this.setData(event.lang);
			}
		);

		this.setData();
	}
	// TODO: qui si ignora il parametro e a ogni cambiamento di lingua si ignora il valore aggiornato e si tiene quello pescato all'inizio
	private setData(lang?: string) {
		this.wcmService
			.getWcmPrivacy(this.localizedCountry.toLowerCase())
			.subscribe(value => {
				this.privacy = value;
			});
	}
}